export default __webpack_public_path__ + "static/media/100 usd layout_02 1.dbff7c14.svg";